import { useAuthToken } from './useAuthToken';

export const useIsAuthenticated = () => {
  const token = useAuthToken();

  return !!token;
};
